// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateOtherSubjectBinding, CreateOtherSubjectBindingSchema } from 'api/gen/CreateOtherSubjectBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOtherSubjectBindingManagerBaseObject, ValidateOtherSubjectBindingManagerBaseObjectSchema } from 'api/gen/ValidateOtherSubjectBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateOtherSubjectBindingManager'),
  binding: t.union([CreateOtherSubjectBindingSchema, t.null]),
});

export const ValidateCreateOtherSubjectBindingManagerSchema = excess(t.intersection([ValidateOtherSubjectBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateOtherSubjectBindingManager extends t.TypeOf<typeof ValidateCreateOtherSubjectBindingManagerSchema> {}
